export const getStrapiMediaUrl = (url = "") => {
  const isExternalUrl = url.startsWith("http") || url.startsWith("//");
  const urlPrefix = isExternalUrl ? "" : process.env.NEXT_PUBLIC_STRAPI_HOST;

  return `${urlPrefix}${url}`;
};
